import { InputField, Invoice } from '@enter/core';
import { Formik, FormikHelpers as FormikActions, FormikProps } from 'formik';
import _ from 'lodash';
import { inject, observer } from 'mobx-react';
import React, { useContext } from 'react';
import { DialogContext } from 'services';
import { RootStore } from 'stores';
import * as Yup from 'yup';
import * as S from './invoice-item-dialog.styles';

type InvoiceItemDialogProps = {
    invoice: Invoice;
    onClose: () => void;
};

interface ILineItem {
    name: string;
    amount: number;
}

const schema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    amount: Yup.number().required('Amount is invalid number'),
});

const initial: ILineItem = {
    name: '',
    amount: 0,
};

export const InvoiceItemDialog: React.FunctionComponent<InvoiceItemDialogProps> = inject('rootStore')(
    observer(
        (props: InvoiceItemDialogProps): React.ReactElement => {
            const rootStore: RootStore = _.get(props, 'rootStore');
            if (!rootStore) {
                return <></>;
            }
            const { claimStore } = rootStore;
            const { invoice, onClose } = props;
            const dialogContext = useContext(DialogContext);

            const handleCancel = (): void => {
                onClose && onClose();
            };
            const handleSubmit = async (values: ILineItem, { setSubmitting }: FormikActions<any>): Promise<void> => {
                if (invoice && invoice.id) {
                    setSubmitting(true);
                    try {
                        const { name, amount } = values;
                        await claimStore.addInvoiceLineItem(invoice.id, name, amount);
                    } catch (err) {
                        dialogContext.showError(err);
                    }
                    setSubmitting(false);
                }
                onClose && onClose();
            };
            const maxLength = 100;
            return (
                <S.DialogBody>
                    <Formik initialValues={initial} validationSchema={schema} onSubmit={handleSubmit}>
                        {(formik: FormikProps<ILineItem>): React.ReactElement => (
                            <>
                                <S.InputRow>
                                    <S.InputName>
                                        <S.Label>Name</S.Label>
                                        <S.FormField name="name" maxLength={maxLength} component={InputField} />
                                    </S.InputName>
                                    <S.InputAmount>
                                        <S.Label>Amount</S.Label>
                                        <S.FormField
                                            name="amount"
                                            maxLength={maxLength}
                                            component={InputField}
                                            type="number"
                                        />
                                    </S.InputAmount>
                                </S.InputRow>
                                <S.ButtonGroup
                                    changed={true}
                                    useNotify={false}
                                    onCancel={handleCancel}
                                    onSave={formik.submitForm}
                                    saveLabel="Save"
                                    saveNotice="Item added"
                                />
                            </>
                        )}
                    </Formik>
                </S.DialogBody>
            );
        },
    ),
);
